import React from "react";
import {ResponsiveDataTableStyled} from "./ResponsiveDataTable.styles";
import {EmptyMessage} from "../EmptyMessage/EmptyMessage";

/**
 * Mobil uyumlu tablo. Ant Design Table ile aynı props'ları alır.
 * Mobilde (≤768px) satırlar kart gibi, her hücrede etiket gösterilir.
 *
 * Columns'da her sütun için onCell ile data-label verin:
 *   {
 *     title: "Adı",
 *     dataIndex: "fullName",
 *     onCell: () => ({ "data-label": "Adı" }),
 *     render: (text, record) => <Link to={...}>{text}</Link>
 *   }
 *
 * @param {Object} props - Ant Design Table props (columns, dataSource, loading, rowKey, pagination, locale, scroll, size, className, ...)
 */
export const ResponsiveDataTable = ({
    locale,
    contentAlign,
    ...rest
}) => {
    return (
        <ResponsiveDataTableStyled
            $contentAlign={contentAlign}
            locale={{
                emptyText: <EmptyMessage />,
                ...locale
            }}
            {...rest}
        />
    );
};
